/**
 * @generated SignedSource<<3db5c04ba20eb6657ea986225d0e415b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorCardFragment_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly membershipType: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorLessonTypeSelect_session">;
  readonly " $fragmentType": "InstructorCardFragment_session";
};
export type InstructorCardFragment_session$key = {
  readonly " $data"?: InstructorCardFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorCardFragment_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InstructorCardFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InstructorLessonTypeSelect_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "membershipType",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "24d6b5cbb683ad0018e500e9f5075535";

export default node;
